module.exports = __webpack_public_path__ + "img/gift-19-c5.d83efc67.png";